import {
  //
  GET_WARNINGS,
  GET_WARNINGS_SUCCESS,
  GET_WARNINGS_FAILURE,
  //
  SAVE_WARNING,
  SAVE_WARNING_SUCCESS,
  SAVE_WARNING_FAILURE,
  //
  UPDATE_WARNING,
  UPDATE_WARNING_SUCCESS,
  UPDATE_WARNING_FAILURE,
  //
  DISMISS_WARNING,
  DISMISS_WARNING_SUCCESS,
  DISMISS_WARNING_FAILURE,
  //
  RECORD_SCHEDULE_REVIEW,
  RECORD_SCHEDULE_REVIEW_SUCCESS,
  RECORD_SCHEDULE_REVIEW_FAILURE,
  //
  ACKNOWLEDGE_WARNING,
  ACKNOWLEDGE_WARNING_SUCCESS,
  ACKNOWLEDGE_WARNING_FAILURE,
  //
  MONITOR_WARNING,
  MONITOR_WARNING_SUCCESS,
  MONITOR_WARNING_FAILURE,
  //
  RESOLVE_WARNING,
  RESOLVE_WARNING_SUCCESS,
  RESOLVE_WARNING_FAILURE,
} from "./constants";

// List
export const getWarnings = (payload, onSuccess) => ({
  type: GET_WARNINGS,
  payload,
  onSuccess,
});
export const getWarningsSuccess = (payload) => ({
  type: GET_WARNINGS_SUCCESS,
  payload,
});
export const getWarningsFailure = (payload) => ({
  type: GET_WARNINGS_FAILURE,
  payload,
});

// Save Template Data
export const saveWarning = (payload, onSuccess) => ({
  type: SAVE_WARNING,
  payload,
  onSuccess,
});
export const saveWarningSuccess = (payload) => ({
  type: SAVE_WARNING_SUCCESS,
  payload,
});
export const saveWarningFailure = (payload) => ({
  type: SAVE_WARNING_FAILURE,
  payload,
});

// Update Template Data
export const updateWarning = (payload, onUpdate) => ({
  type: UPDATE_WARNING,
  payload,
  onUpdate,
});
export const updateWarningSuccess = (payload) => ({
  type: UPDATE_WARNING_SUCCESS,
  payload,
});
export const updateWarningFailure = (payload) => ({
  type: UPDATE_WARNING_FAILURE,
  payload,
});

// Dismiss with reason — payload: { uuid, dismiss_type, dismiss_reason }
export const dismissWarning = (payload, onSuccess) => ({
  type: DISMISS_WARNING,
  payload,
  onSuccess,
});
export const dismissWarningSuccess = (payload) => ({
  type: DISMISS_WARNING_SUCCESS,
  payload,
});
export const dismissWarningFailure = (payload) => ({
  type: DISMISS_WARNING_FAILURE,
  payload,
});

// Record a schedule-review action on an alert — payload:
// { uuid, schedule_uuid, action, resolve? }
export const recordScheduleReview = (payload, onSuccess) => ({
  type: RECORD_SCHEDULE_REVIEW,
  payload,
  onSuccess,
});
export const recordScheduleReviewSuccess = (payload) => ({
  type: RECORD_SCHEDULE_REVIEW_SUCCESS,
  payload,
});
export const recordScheduleReviewFailure = (payload) => ({
  type: RECORD_SCHEDULE_REVIEW_FAILURE,
  payload,
});

// "Looks fine" — acknowledge the alert. payload: { uuid }
export const acknowledgeWarning = (payload, onSuccess) => ({
  type: ACKNOWLEDGE_WARNING,
  payload,
  onSuccess,
});
export const acknowledgeWarningSuccess = (payload) => ({
  type: ACKNOWLEDGE_WARNING_SUCCESS,
  payload,
});
export const acknowledgeWarningFailure = (payload) => ({
  type: ACKNOWLEDGE_WARNING_FAILURE,
  payload,
});

// "Check later" — park for follow-up. payload: { uuid, review_due_at, reason?, note? }
export const monitorWarning = (payload, onSuccess) => ({
  type: MONITOR_WARNING,
  payload,
  onSuccess,
});
export const monitorWarningSuccess = (payload) => ({
  type: MONITOR_WARNING_SUCCESS,
  payload,
});
export const monitorWarningFailure = (payload) => ({
  type: MONITOR_WARNING_FAILURE,
  payload,
});

// "Actioned" — resolve with an action taken. payload: { uuid, action?, note? }
export const resolveWarning = (payload, onSuccess) => ({
  type: RESOLVE_WARNING,
  payload,
  onSuccess,
});
export const resolveWarningSuccess = (payload) => ({
  type: RESOLVE_WARNING_SUCCESS,
  payload,
});
export const resolveWarningFailure = (payload) => ({
  type: RESOLVE_WARNING_FAILURE,
  payload,
});
